<template>
  <div class="row">
    <div class="col-12 h-100 px-1">
      <div class="d-flex justify-content-end mr-2 pr-1">
        <span v-if="isSaving">
          <b-button
            variant="primary"
            size="lg"
            disabled
          >
            <b-spinner small />
            {{ 'saving' | i18n }}
          </b-button>
        </span>
        <span v-else>
          <b-button
            v-if="mainInfo.operationalArea.type && isMyTeam"
            variant="primary"
            size="lg"
            class="ml-3"
            :disabled="!mainInfo.team"
            @click="() => save(false)"
          >
            {{ 'save' | i18n }}
          </b-button>
          <b-button
            v-if="mainInfo.operationalArea.type && isMyTeam"
            variant="primary"
            size="lg"
            class="ml-3"
            :disabled="!mainInfo.team"
            @click="() => save(true)"
          >
            {{ 'Save & Close' | i18n }}
          </b-button>
        </span>
      </div>
      <div
        class="main-content-log table-wrapper"
        :style="`${mainInfo.operationalArea.type ? '' : 'display: flex;justify-content: center;align-items: center;'} overflow-x: hidden;`"
        v-if="!loading"
      >
        <div class="buttons-wrapper-log" v-if="!mainInfo.operationalArea.type">
          <b-button variant="primary" size="sm" v-for="type in operationalAreas" :key="type.id" @click="typeSelected(type)">
            {{ type.name | i18n }}
          </b-button>
        </div>
        <div class="components-block" v-else>
          <div class="inputs-block">
            <BlockHeader :name="`${$translate('Shift Log for Facility')} ${$translate(mainInfo.operationalArea.name)}`" lg="12" />
          </div>
          <ShiftStaffing
            v-model="mainInfo"
            :teamsOptions="teamsOptions"
            :users="users"
            :updateUsers="updateUsers"
            :shiftStaffing="shiftStaffing"
            :shiftPositions="shiftPositions"
            :isMyTeam="isMyTeam"
          />
          <OperatingStates v-model="operatingStates" :isPowerPlant="isPowerPlant" :isUpstreamPlant="isUpstreamPlant" :isMyTeam="isMyTeam" />
          <SupplyAndDisposal v-model="supplyAndDisposal" v-if="isUpstreamPlant" :isMyTeam="isMyTeam" />
          <OperatingData v-model="operatingData" v-if="isUpstreamPlant" :isMyTeam="isMyTeam" />
          <EventsExternalImpact v-model="eventsExternalImpact" v-if="isPowerPlant" :isMyTeam="isMyTeam" />
          <OperationalSafety v-model="operationalSafety" :isMyTeam="isMyTeam" />
          <ExternalCompanyDeployment
            v-model="externalCompanyDeployment"
            :updateCompanies="updateCompanies"
            :companies="companies"
            :isMyTeam="isMyTeam"
          />
          <div class="inputs-block">
            <BlockHeader :name="$translate('Comments')" />
          </div>
          <Textarea v-model="furtherComments" :viewMode="!isMyTeam" form-group-id="Further Comments" placeholder="Further Comments" rows="20" />
        </div>
      </div>
      <Loader v-else />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import hash from 'object-hash';
import Notification from '../../../common/notification';
import BlockHeader from '../../../common/block-header';
import Loader from '../../../common/loader';
import Textarea from '../../../common/textarea';
import { SHIFT_TYPES } from '../../../../../../../../constants';
import { NotificationMixin, AuthMixin } from '../../../../../mixins';
import api from '../../../../api';

import ShiftStaffing from './components/shift-staffing';
import OperatingStates from './components/operating-states';
import EventsExternalImpact from './components/events-with-external-impact';
import OperationalSafety from './components/operational-safety';
import ExternalCompanyDeployment from './components/external-company-deployment';
import SupplyAndDisposal from './components/supply-and-disposal';
import OperatingData from './components/operating-data';

export default {
  title: 'AddShiftLog',
  components: {
    ShiftStaffing,
    BlockHeader,
    OperatingStates,
    EventsExternalImpact,
    OperationalSafety,
    ExternalCompanyDeployment,
    SupplyAndDisposal,
    OperatingData,
    Loader,
    Textarea,
  },
  mixins: [NotificationMixin, AuthMixin],
  data() {
    return {
      mainInfo: {
        operationalArea: {},
        date: moment().format(),
        team: null,
      },
      operationalAreas: [],
      shiftStaffing: {},
      operatingStates: {},
      externalCompanyDeployment: {},
      eventsExternalImpact: {},
      operationalSafety: {},
      supplyAndDisposal: {},
      operatingData: {},
      shiftPositions: [],
      initialShiftStaffing: [],
      shiftPositionsObj: [],
      teams: [],
      teamsOptions: [],
      users: null,
      companies: [],
      id: this.$route.params.id,
      lockDay: false,
      startDay: null,
      shitTemplate: null,
      loading: true,
      furtherComments: '',
      isSaving: false,
    };
  },
  computed: {
    isMyTeam: function () {
      if (this.isUser) {
        return false;
      }

      if (this.isCommonAdmin) {
        return true;
      }

      // const now = moment.utc().set({ h: 0, m: 0, s: 0 });
      // const dayDate = moment.utc(this.mainInfo.date).set({ h: 23, m: 59, s: 59 });

      // if (!dayDate.isAfter(now)) {
      //   return false;
      // }

      const team = this.teams.find((t) => t.id === this.mainInfo.team);
      if (!team) {
        return false;
      }

      const leaders = [];
      if (team.shiftLeader1) {
        leaders.push(team.shiftLeader1.id);
      }
      if (team.shiftLeader2) {
        leaders.push(team.shiftLeader2.id);
      }
      if (team.shiftLeader3) {
        leaders.push(team.shiftLeader3.id);
      }

      if (leaders.includes(this.auth.id)) {
        return true;
      }
      return false;
    },
    isPowerPlant: function () {
      return this.mainInfo.operationalArea.type === SHIFT_TYPES.POWER_PLANT;
    },
    isUpstreamPlant: function () {
      return this.mainInfo.operationalArea.type === SHIFT_TYPES.UPSTREAM_PLANT;
    },
  },
  watch: {
    mainInfo: {
      handler: function (mainInfo) {
        this.loadDay(mainInfo);
      },
      deep: true,
    },
  },
  async created() {
    this.operationalAreas = (await api.operationalArea.get()).filter((s) => s.type);
    this.onCreate();
  },
  methods: {
    onBack() {
      let isAnyChanges = false;

      const arr = ['operationalSafety', 'operatingStates', 'externalCompanyDeployment', 'eventsExternalImpact', 'supplyAndDisposal', 'operatingData'];
      arr.forEach((n) => {
        Object.values(this[n]).forEach((v) => {
          if (v && (v.value || v.comment)) {
            isAnyChanges = true;
          }
        });
      });

      if (hash(this.shiftStaffing) !== hash(this.initialShiftStaffing)) {
        isAnyChanges = true;
      }

      if (isAnyChanges) {
        const answer = window.confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
        if (!answer) {
          return;
        }
      }

      this.mainInfo = {
        operationalArea: {},
        date: moment().format(),
        team: null,
      };
      this.shiftStaffing = {};
      this.operatingStates = {};
      this.externalCompanyDeployment = {};
      this.eventsExternalImpact = {};
      this.supplyAndDisposal = {};
      this.operatingData = {};
      this.operationalSafety = {};
      this.shiftPositions = [];
      this.initialShiftStaffing = [];
      this.shiftPositionsObj = [];
      this.teams = [];
      this.teamsOptions = [];
      this.users = null;
      this.companies = [];
      this.id = this.$route.params.id;
      this.startDay = null;
      this.shitTemplate = null;
      this.loading = false;
      this.furtherComments = '';
    },
    async onCreate() {
      this.loading = true;
      this.lockDay = true;
      let shiftLog;
      const q = this.$route.query;
      if (q && q.operationalAreaId && q.date && q.team) {
        const operationalArea = await api.operationalArea.getById(q.operationalAreaId);
        shiftLog = await api.shiftDay.getOne({ operationalAreaId: operationalArea.id, date: q.date, team: q.team });
        if (shiftLog.id) {
          this.id = shiftLog.id;
        } else {
          this.mainInfo.date = moment.utc(q.date).format();
          this.mainInfo.team = q.team;
          await this.typeSelected(operationalArea);
          setTimeout(() => {
            this.loadDay();
          }, 500);
        }
      }

      if (this.id) {
        if (!shiftLog) {
          shiftLog = await api.shiftDay.getById(this.id);
          if (!shiftLog.id) {
            return this.$router.go(-1);
          }
        }
        this.mainInfo.date = moment.utc(shiftLog.date).format();
        this.mainInfo.team = shiftLog.team.id;
        await this.typeSelected(shiftLog.operationalArea);
        const users = shiftLog.team.users;

        this.users = [
          ...users.filter((u) => {
            if (u.startWorkingDate) {
              return moment.utc(shiftLog.date).isSameOrAfter(moment(u.startWorkingDate).format('YYYY-MM-DD'));
            } else {
              return true;
            }
          }),
        ];

        shiftLog.team.users.forEach((u) => {
          if (u.shiftPosition && u.shiftPosition.id) {
            this.shiftStaffing[u.id] = u.shiftPosition.id;
          }
        });
        this.initialShiftStaffing = JSON.parse(JSON.stringify(this.shiftStaffing));

        this.companies = shiftLog.companies;
        shiftLog.companies.forEach((c) => {
          this.externalCompanyDeployment[c.id] = c.comment;
        });

        this.operatingStates = shiftLog.operatingStates || {};
        this.furtherComments = shiftLog.furtherComments || '';
        this.eventsExternalImpact = shiftLog.eventsExternalImpact || {};
        this.supplyAndDisposal = shiftLog.supplyAndDisposal || {};
        this.operatingData = shiftLog.operatingData || {};
        this.operationalSafety = shiftLog.operationalSafety || {};
      }

      this.loading = false;
      setTimeout(() => {
        this.lockDay = false;
      }, 100);
    },
    updateUsers(users) {
      this.users = users.filter((u) => {
        if (u.startWorkingDate) {
          return moment.utc(this.mainInfo.date).isSameOrAfter(moment(u.startWorkingDate).format('YYYY-MM-DD'));
        } else {
          return true;
        }
      });
    },
    updateCompanies(companies) {
      this.companies = companies;
    },
    async loadDay(mainInfo) {
      if (this.lockDay) {
        return;
      }
      this.users = null;
      this.shiftStaffing = {};
      this.initialShiftStaffing = {};
      const d = mainInfo || this.mainInfo;

      if (!d.date || !d.team || !d.operationalArea) {
        return;
      }
      const shifts = this.generateShift(d);
      this.teamsOptions = this.shitTemplate.teams.map((t) => ({ value: t.id, text: `${t.name} - ${this.$translate(shifts[t.id])}` }));

      const date = moment(d.date);
      const shiftDay = await api.shiftDay.get({
        year: date.format('YYYY'),
        month: date.format('MM'),
        day: date.format('DD'),
        teamId: d.team,
        operationalArea: d.operationalArea.id,
      });
      if (shiftDay && shiftDay.id) {
        this.users = shiftDay.team.users ? shiftDay.team.users : [];
        this.users.forEach((u) => {
          if (u.shiftPosition && u.shiftPosition.id) {
            this.shiftStaffing[u.id] = u.shiftPosition.id;
          }
        });
        this.initialShiftStaffing = JSON.parse(JSON.stringify(this.shiftStaffing));

        this.companies = shiftDay.companies;
        shiftDay.companies.forEach((c) => {
          this.externalCompanyDeployment[c.id] = c.comment;
        });

        this.operatingStates = shiftDay.operatingStates || {};
        this.furtherComments = shiftDay.furtherComments || '';
        this.eventsExternalImpact = shiftDay.eventsExternalImpact || {};
        this.supplyAndDisposal = shiftDay.supplyAndDisposal || {};
        this.operatingData = shiftDay.operatingData || {};
        this.operationalSafety = shiftDay.operationalSafety || {};
      } else {
        const team = this.teams.find((t) => t.id === d.team);
        this.users = team.users;
        this.users.forEach((u) => {
          if (u.shiftPosition && u.shiftPosition.id) {
            this.shiftStaffing[u.id] = u.shiftPosition.id;
          }
        });
        this.initialShiftStaffing = JSON.parse(JSON.stringify(this.shiftStaffing));
      }
      this.users = this.users.filter((u) => {
        if (u.startWorkingDate) {
          return moment.utc(this.mainInfo.date).isSameOrAfter(moment(u.startWorkingDate).format('YYYY-MM-DD'));
        } else {
          return true;
        }
      });
    },
    async typeSelected(operationalArea) {
      this.mainInfo.operationalArea = operationalArea;
      const positions = await api.shiftPositions.get({ operationalArea: this.mainInfo.operationalArea.id });
      this.shiftPositions = positions.map((i) => {
        this.shiftPositionsObj[i.id] = i;
        return { value: i.id, text: i.name };
      });

      const shitTemplate = (await api.shiftTemplate.get({ operationalArea: this.mainInfo.operationalArea.id }))[0];
      this.shitTemplate = shitTemplate;

      const settings = await api.settings.getSettings();
      let startDay = settings.scheduleStartDate;
      if (!startDay) {
        Notification({ type: 'error', message: 'No start date. Please set the start date in the settings.' });
        return;
      }
      this.startDay = moment(startDay).format('YYYY-MM-DD');

      this.teams = shitTemplate.teams;
      const shifts = this.generateShift();
      this.teamsOptions = shitTemplate.teams.map((t) => ({ value: t.id, text: `${t.name} - ${this.$translate(shifts[t.id])}` }));

      if (!this.id && !this.$route.query.team) {
        this.teams.forEach((t) => {
          const leaders = t.users.map((u) => u.id);
          if (t.shiftLeader1) {
            leaders.push(t.shiftLeader1.id);
          }
          if (t.shiftLeader2) {
            leaders.push(t.shiftLeader2.id);
          }
          if (t.shiftLeader3) {
            leaders.push(t.shiftLeader3.id);
          }
          if (leaders.includes(this.auth.id)) {
            this.mainInfo.team = t.id;
          }
        });
      }
    },
    generateShift(d) {
      const mainInfo = d || this.mainInfo;
      const currentMonth = moment(mainInfo.date).set('date', 1).format('YYYY-MM-DD');

      const difference = moment(currentMonth).diff(moment(this.startDay), 'days');
      const ids = this.shitTemplate.teams.map((i) => i.id);
      const result = {};
      Array.from({ length: moment(this.selectedDate).daysInMonth() }).map((_, i) => {
        if (i == moment(mainInfo.date).format('DD') - 1) {
          const y = Math.abs((i + difference) % Object.keys(this.shitTemplate.template).length) + 1;
          ids.forEach((id) => {
            result[id] = this.shitTemplate.template[y][id];
          });
        }
      });
      return result;
    },
    async save(close) {
      try {
        this.isSaving = true;
        const payload = {
          date: moment(this.mainInfo.date).format('YYYY-MM-DD'),
          teamId: this.mainInfo.team,
          operationalArea: this.mainInfo.operationalArea,
          operatingStates: this.operatingStates,
          eventsExternalImpact: this.eventsExternalImpact,
          supplyAndDisposal: this.supplyAndDisposal,
          operatingData: this.operatingData,
          operationalSafety: this.operationalSafety,
          furtherComments: this.furtherComments,
          users: this.users.map((u) => {
            return {
              ...u,
              shiftPosition: this.shiftStaffing[u.id] ? this.shiftPositionsObj[this.shiftStaffing[u.id]] : u.shiftPosition,
            };
          }),
          companies: this.companies.map((c) => {
            return {
              ...c,
              comment: this.externalCompanyDeployment[c.id],
            };
          }),
        };
        await api.shiftDay.save(payload);
        if (close) {
          this.$router.go(-1);
        }
        Notification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        Notification({ type: 'error', message: this.$translate(err.message) });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.buttons-wrapper-log {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
}
.buttons-wrapper-log button {
  min-width: 150px;
  margin: 10px 0;
}

.main-content-log {
  width: 100%;
  min-height: calc(100vh - 120px);
  background: #ffffff;
  padding: 10px;
  overflow-y: auto;
}

.input-log-line {
  align-items: center;
  display: flex;
  width: 100%;
  padding-top: 3px;
  div {
    width: 100%;
  }
}

.button-log-line {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-log-line {
  display: flex;
  align-items: center;
}

.loader-wrapper {
  max-height: 20px;
  transform: scale(0.5);
  position: absolute;
  margin-top: -40px;
  margin-left: -40px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
